import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Panel, Loader } from "@culturehq/components";
import * as CHQ from "chq";

import { useGet } from "app/hooks";
import { Trans } from "app/utils";

import ErrorBoundary from "components/common/ErrorBoundary";

import "./drawDoughnutTotal";
import getColorList from "./getColorList";

const getData = (types: CHQ.EventType[]) => {
  const totals = types.map(({ total }) => total);

  return {
    labels: types.map(({ name }) => name),
    datasets: [{
      data: totals,
      backgroundColor: getColorList(types.length)
    }],
    text: totals.reduce((left, right) => left + right, 0)
  };
};

const options = {
  responsive: true,
  maintainAspectRatio: false,
  legend: {
    display: true,
    position: "bottom",
    labels: {
      usePointStyle: true
    }
  },
  tooltips: {
    enabled: false
  },
  data: { display: false },
  scales: {
    ChartScales: {
      display: false
    }
  },
  plugins: {
    datalabels: {
      display: false
    },
    borderWidth: 0
  },
  cutoutPercentage: 80,
  elements: {
    arc: {
      borderWidth: 0
    }
  }
};

export type ListEventTypes = {
  types: CHQ.EventType[];
};

const DoughnutChartContent: React.FC = () => {
  const get = useGet<ListEventTypes>("/analytics/events/types");

  if (get.getting) {
    return <Loader loading />;
  }

  if (get.error) {
    throw get.error;
  }

  return <Doughnut data={getData(get.got.types)} options={options} />;
};

const DoughnutChart: React.FC = () => (
  <Panel>
    <Panel.Body className="card_holder">
      <div className="card_title">
        <h3>
          <Trans>Programs by Type</Trans>
        </h3>
      </div>
      <ErrorBoundary>
        <div className="card_info chart_wrap">
          <DoughnutChartContent />
        </div>
      </ErrorBoundary>
    </Panel.Body>
  </Panel>
);

export default DoughnutChart;
